

/**
 * Clase para manejo de notificaciones toast
 * @class AppToast
 */
class AppToast {
    /**
     * Constructor del AppToast
     */
    constructor() {
        this.effectIn = 'animate__flipInX';
        this.effectOut = 'animate__flipOutX';
    }

    /**
     * Quita toasts que coinciden con selector (animación igual que al cerrar con click).
     * @private
     * @param {string} selector - selector CSS dentro de `.app-toaster`
     */
    _dismissMatching(selector) {
        const toaster = document.querySelector('.app-toaster');
        if (!toaster) return;
        toaster.querySelectorAll(selector).forEach((toast) => {
            toast.classList.remove(this.effectIn);
            toast.classList.add(this.effectOut);
            toast.addEventListener(
                'animationend',
                (e) => {
                    e.target.remove();
                },
                { once: true },
            );
        });
    }

    /**
     * Oculta todos los toasts visibles.
     */
    dismissAll() {
        this._dismissMatching('.app-toast');
    }

    /**
     * Muestra un toast
     * @param {string} html - Contenido HTML del toast
     * @param {string} type - Tipo de toast (success, warning, danger, info)
     * @param {boolean|number} permanent - Si es true, permanente; si es número, delay en ms
     * @param {string|Function} click - 'exit' para cerrar al click, o función callback
     * @param {string} classes - Clases CSS adicionales
     * @returns {HTMLElement|null} Elemento del toast o null si hay error
     */
    show(
        html = '',
        type = 'success',
        permanent = false, // or Delay
        click = 'exit',
        classes = false
    ) {
        if (typeof html !== 'string') {
            html = String(html || '');
        }

        const validTypes = ['success', 'warning', 'danger', 'info'];
        if (!validTypes.includes(type)) {
            type = 'success';
        }

        const toaster = document.querySelector('.app-toaster');
        if (!toaster) {
            return null;
        }

        this._dismissMatching('.app-toast:not(.uploading):not(.toast-offline)');

        const toast = document.createElement('div');
        toast.className = `animate__animated ${this.effectIn} app-toast p-3 rounded ${type} text-bg-${type}`;
        toast.innerHTML = html;

        let words = html.split(' ').length * 250;
        if (words < 4000) words = 4000;
        let time = Number.isInteger(permanent) ? permanent : words;

        if (classes) {
            classes.split(' ').forEach((className) => {
                toast.classList.add(className);
            });
        }

        if (click) {
            toast.classList.add('cursor-pointer');
            if (click === 'exit') {
                toast.addEventListener('click', function (e) {
                    e.stopPropagation();
                    this.classList.remove('animate__flipInX');
                    this.classList.add('animate__flipOutX');
                    this.addEventListener('animationend', (e) => { e.target.remove() });
                });
            } else {
                toast.addEventListener('click', function (e) {
                    e.stopPropagation();
                    click();
                });
            }
        }

        if (permanent === false || Number.isInteger(permanent)) {
            setTimeout(() => {
                toast.classList.remove(this.effectIn);
                toast.classList.add(this.effectOut);
                toast.addEventListener('animationend', (e) => e.target.remove());
            }, time);
        }

        toaster.append(toast);

        return toast;
    }
}

const Toast = new AppToast();
export { AppToast, Toast }